import { render, staticRenderFns } from "./LanguageEdit.vue?vue&type=template&id=57afec5f&"
import script from "./LanguageEdit.vue?vue&type=script&lang=js&"
export * from "./LanguageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports